import { useState, useEffect, JSX, CSSProperties } from 'react';

import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './../../../shared/StoreContainer/actionCreators';

import { Config } from "../../../App";
import { Watermark } from "../../watermark";
import { LayersFilter } from "./../../layers-filter";
import { FeatureInfo } from "./../../feature-info";
import { GetContact } from "./../../get-contact";
import { getCenterCoordinates } from '../../../shared/RKApi';

import FilterIcon from './../../../shared/icons/Filter.svg'
import classNames from "./styles.module.scss"

import { toMercator } from '@turf/projection';

import "./style.css"
import { sendMetricContacts } from '../../../shared/MetricApi';

type UserContactType = {
  name: string,
  email: string,
  phone: string,
  comment: string
}

export const MainSample = (props: {
  map: JSX.Element
}) => {
  const dispatch: Dispatch<any> = useDispatch();

  //@ts-ignore
  const filtersActiveContainer = useSelector((state) => (state?.containerFilterActive));
  //@ts-ignore
  const mapOpenedContainer = useSelector((state) => (state?.containerMapOpened));
  //@ts-ignore
  const drawEnabledContainer = useSelector((state) => (state?.containerDrawEnabled));

  const idInContainer = useSelector((state: any) => (state?.containerUser?.user?.id));

  const [footerText, setFooterText] = useState<Array<string> | null>(null);
  const [locations, setLocations] = useState<[] | null>(null)
  const [russiaStats, setRussiaStats] = useState<any | null>(null)

  const [userContact, setUserContact] = useState<UserContactType>({ name: "", email: "", phone: "", comment: "" })

  const [showMore, setShowMore] = useState<number | null>(null);

  function mapButtonClick(block: boolean = false, coords?: [number, number]) {
    if (!mapOpenedContainer.opened || (block && !mapOpenedContainer.opened)) {
      dispatch(actions.setMapOpened(true, coords));
      setTimeout(() => {
        dispatch(actions.setFilterActive(true));
      }, 1500)
    }
    else
      if (!block) {
        dispatch(actions.setContactOpened(false));
        if (!drawEnabledContainer.enabled) {
          dispatch(actions.turnOffAllLayers());
          dispatch(actions.setDrawEnabled(true));
          dispatch(actions.setFilterActive(false));
        }
        else {
          dispatch(actions.setDrawEnabled(false));
        }
      }
  }

  const updUserContact = (key: keyof UserContactType, value: string) => {
    const copy = JSON.parse(JSON.stringify(userContact));
    copy[key] = value;
    setUserContact(copy);
  }

  useEffect(() => {
    getCenterCoordinates(setLocations);
  }, [])

  useEffect(() => {

    !footerText
      //@ts-ignore
      && Config.texts.footer.docToFetch
      //@ts-ignore
      && fetch(Config.texts.footer.docToFetch)
        .then(r => {
          r.json()
            .then(data => {
              setRussiaStats(data);
            })
        })
        .catch(e => setFooterText(['']))
  }, [])

  useEffect(() => {
    if (document.getElementById('topButton')) {
      document.getElementById('topButton')!.className = classNames.topButton + ' ' + (mapOpenedContainer.opened ? classNames.topButtonInMap : '')
    }
    if (document.getElementById('blockMap')) {
      document.getElementById('blockMap')!.className = classNames.blockMap + ' ' + (mapOpenedContainer.opened ? classNames.blockMapOpened : '')
    }
    // if (document.getElementById('title')) {
    //   document.getElementById('title')!.className = classNames.title + ' ' + (mapOpenedContainer.opened ? classNames.titleNone : '')
    // }
    // if (document.getElementById('subtitle')) {
    //   document.getElementById('subtitle')!.className = classNames.subtitle + ' ' + (mapOpenedContainer.opened ? classNames.subtitleNone : '')
    // }
    // if (document.getElementById('infoContainer')) {
    //   document.getElementById('infoContainer')!.className = classNames.infoContainer + ' ' + (mapOpenedContainer.opened ? classNames.infoContainerNone : '')
    // }

    if (document.getElementById('mapButton'))
      document.getElementById('mapButton')!.className = classNames.mapButton + ' ' + (mapOpenedContainer.opened ? classNames.mapButtonOpened : '')

    document.getElementById('mapButton')!.addEventListener('transitionend', () => {
      if (mapOpenedContainer.opened) {
        if (document.getElementById('topButton')) {
          console.log(parseFloat(getComputedStyle(document.getElementById('topButton')!).getPropertyValue('width').split('px')[0]))
          document.getElementById('topButton')
            && document.documentElement.style.setProperty('--map-button-left-offset', `${parseFloat(getComputedStyle(document.getElementById('topButton')!).getPropertyValue('width').split('px')[0]) + 15}px`);
        }
        // document.documentElement.style.overflow = 'hidden'
      }
      else {
        // document.documentElement.style.overflow = 'auto'
      }
    })
  }, [mapOpenedContainer])

  const getMapStyle = (): CSSProperties => {
    return mapOpenedContainer.opened ? {
      // margin: "30px auto 0",
      // minHeight: "80vh",
    } : { margin: "30px auto 0", minHeight: "210px" }
  }

  let priceToPretty = (price: number) => {
    return ("" + (price || 0).toFixed()).split('').reverse().map((s, i) => { return s + ((i > 0) && (i % 3 === 0) ? ' ' : ''); }).reverse().join('');
  }

  const openRegion = (region: any) => {
    window.location.assign("#sandbox")
    const finded = locations && locations.find((loc: any) => loc._id === region._id) as any;
    finded && mapButtonClick(false, toMercator([finded.lon, finded.lat]));
  }

  // console.log(locations, russiaStats)

  let statLines: any = null;
  let statHeader = null;
  let statMainHeader = null;
  if (locations && russiaStats) {
    statHeader = `Всего по России ${russiaStats.totalCount} ОКС на ${Math.round(russiaStats.totalTax / 1000000000)} млрд рублей в год`;
    statMainHeader =
      <span>
        {Math.round(russiaStats.totalTax / 1000000000)} миллиардов —
        <span className={classNames.activeLink}
          onClick={() => {
            mapButtonClick(true)
          }}
        > сколько из них ваши?</span>
      </span>

    statLines = [];


    if (russiaStats.regions) {
      let regionCodes = Object.keys(russiaStats.regions);
      regionCodes.forEach(code => {

        //@ts-ignore
        let region: any = locations.find(r => (r.code === parseInt(code)));
        let stat = russiaStats.regions[code];

        region && statLines.push({
          _id: region._id,
          name: region.name,
          link: './' + region.urlpart + '/',
          t21: priceToPretty((stat.type21extraTax + stat.type21roomsExtraTax) / 1000000) + ' млн',
          t22: priceToPretty((stat.type22extraTax + stat.type22roomsExtraTax) / 1000000) + ' млн',
          t23: priceToPretty((stat.type23extraTax + stat.type23roomsExtraTax) / 1000000) + ' млн',
          t24: priceToPretty((stat.type24extraTax + stat.type24roomsExtraTax) / 1000000) + ' млн'
        })

      });
    }

  }


  return (
    <>
      {
        <div className={classNames.contentContainer} id="sandbox" style={getMapStyle()}>
          <div id='topButton' className={classNames.topButton}>
            <p className={classNames.buttonTextPadding}>{Config.texts.appName}</p>
            {mapOpenedContainer.opened ? <img src={FilterIcon} id='FilterIcon' className={classNames.pointer + (filtersActiveContainer.active ? (' ' + classNames.active) : '')} alt="filter button" onClick={(e) => {
              dispatch(actions.setFilterActive(!filtersActiveContainer.active));
            }}
            /> : ''}
          </div>
          <div id='blockMap' className={classNames.blockMap + ' ' + classNames.darkBlock}
            onClick={() => {
              mapButtonClick(true)
            }}
          >
            <div id="mapButton" className={classNames.mapButton}
              onClick={() => {
                mapButtonClick()
              }}
            >
              {/* @ts-ignore */}
              <p className={classNames.buttonTextPadding}>{mapOpenedContainer.opened ? (drawEnabledContainer.enabled ? Config.texts.drawing.stop : Config.texts.drawing.start) : Config.texts.drawing.default}</p>
            </div>
            {props.map}
          </div>
          <LayersFilter map={props.map} />
          <FeatureInfo />

          <GetContact />

          {mapOpenedContainer.opened && <Watermark />}
        </div >
      }

    </>
  );
}